// extracted by mini-css-extract-plugin
export default {"button":"Feedback_button__BtSIz","buttonsContainer":"Feedback_buttonsContainer__kmY6f"};